import { createColumnHelper } from "@tanstack/react-table";
import {
  ArrowDownTrayIcon,
  CheckCircleIcon,
  ClockIcon,
  XCircleIcon,
  BoltIcon,
  PauseCircleIcon,
} from "@heroicons/react/24/outline";

const columnHelper = createColumnHelper();

export const inventorySparesTableColumnsConfig = (
 
  handleDownload,
  handleNavigateToLotList,
  handleDelete,
) => [
  columnHelper.accessor("request_id", {
    header: "Request Id",
    cell: (info) => info.getValue(),
  }),

  columnHelper.accessor("quantity", {
    header: "Quantity",
    cell: (info) => info.getValue(),
  }),

  /* ---------------- Status (Active / Inactive) ---------------- */
  columnHelper.accessor("status", {
    header: "Status",
    cell: ({ getValue }) => {
      const status = getValue()?.toLowerCase();

      const statusConfig = {
        active: {
          label: "Active",
          bg: "#E8F5E9",
          color: "#2E7D32",
          Icon: BoltIcon,
        },
        deactivated: {
          label: "Inactive",
          bg: "#F5F5F5",
          color: "#616161",
          Icon: PauseCircleIcon,
        },
      };

      const config = statusConfig[status];
      if (!config) return "-";

      const { label, bg, color, Icon } = config;

      return (
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            padding: "4px 10px",
            borderRadius: "999px",
            fontSize: "12px",
            fontWeight: 500,
            backgroundColor: bg,
            color,
            whiteSpace: "nowrap",
          }}
        >
          <Icon style={{ width: 14, height: 14 }} />
          {label}
        </div>
      );
    },
  }),

  /* ---------------- Approval Status ---------------- */
 

  columnHelper.display({
    id: "download",
    header: <div style={{ textAlign: "center" }}>Download</div>,
    cell: (props) => (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <button
          disabled={props.row.original.approval_status === "pending for status"}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            padding: "6px 12px",
            background: "rgba(58, 63, 143, 0.08)",
            color: "#3A3F8F",
            border: "1px solid rgba(58, 63, 143, 0.25)",
            borderRadius: "6px",
            fontSize: "13px",
            fontWeight: 500,
            cursor: "pointer",
            transition: "all 0.18s ease",
          }}
          onClick={() => handleDownload(props.row.original.request_id)}
        >
          <ArrowDownTrayIcon style={{ width: 15, height: 15 }} />
          Download
        </button>
      </div>
    ),
  }),
  columnHelper.display({
    id: "actions",
    header: <div style={{ textAlign: "center" }}>Action</div>,
    cell: (props) => {
      const isDisabled =
        props.row.original.approval_status === "pending for status";

      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          {/* View Inventory */}
          <button
            disabled={isDisabled}
            onClick={() => handleNavigateToLotList(props.row.original.request_id)}
            style={{
              padding: "6px 12px",
              background: "linear-gradient(135deg, #2F3567 0%, #5561A0 100%)",
              color: "#FFFFFF",
              fontWeight: 500,
              fontSize: "13px",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              transition: "all 0.3s ease",
              boxShadow: "0 2px 6px rgba(47,53,103,0.3)",
            }}
          >
            View Inventory
          </button>

          {/* Delete Button */}
          <button
            disabled={isDisabled}
            onClick={() => handleDelete(props.row.original.request_id)}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              padding: "6px 12px",
              background: "rgba(229, 57, 53, 0.08)",
              color: "#E53935",
              border: "1px solid rgba(229, 57, 53, 0.3)",
              borderRadius: "6px",
              fontSize: "13px",
              fontWeight: 500,
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              if (!isDisabled) {
                e.currentTarget.style.background = "rgba(229, 57, 53, 0.16)";
                e.currentTarget.style.transform = "translateY(-1px)";
              }
            }}
            onMouseLeave={(e) => {
              if (!isDisabled) {
                e.currentTarget.style.background = "rgba(229, 57, 53, 0.08)";
                e.currentTarget.style.transform = "translateY(0)";
              }
            }}
          >
            <XCircleIcon style={{ width: 15, height: 15 }} />
            Delete
          </button>
        </div>
      );
    },
  }),
];
